import React from 'react';
import PropTypes from 'prop-types';

import MiniOverlayModal from 'dpl/common/mini_overlay_modal/components/MiniOverlayModal';
import SmartImage from 'dpl/components/SmartImage';
import SmartLink from 'dpl/components/SmartLink';
import { EDUCATION_TIPS } from 'dpl/breeder_search_results/utils/constants';
import { LEARNING_CENTER_PATH } from 'dpl/shared/constants/urls';
import { OPT_OUT_CLASS } from 'dpl/components/FixedScrollWrapper';
import { isMobileUA } from 'dpl/shared/utils';

const IS_MOBILE_UA = isMobileUA();

export default function EducationModuleModal({ onCloseClick }) {
  return (
    <MiniOverlayModal
      className="BreederSearchResultsEducationModuleModal"
      scrollableContent
      contentClassName={`BreederSearchResultsEducationModuleModal__contents bg-white br3 no-scrollbars overflow-y-auto ${OPT_OUT_CLASS}`}
      onCloseClick={onCloseClick}
      maxWidth="600px"
    >
      <div className="bg-yellow-10 pb10-md pt8-md ph10-sm pb8 pt16 ph6 flex flex-column min-h-100">
        <p className="mb8 f5 f6-sm fw-medium">How Good Dog works</p>

        {EDUCATION_TIPS.map((tip, idx) => {
          const { modalTitle, description, modalImg } = tip;

          return (
            <div
              className="flex flex-sm-row flex-column align-items-center mv6-sm mv7-md mb10"
              key={idx}
            >
              <div className="mb6 mb0-sm">
                <SmartImage
                  alt={modalTitle}
                  src={modalImg}
                  width={IS_MOBILE_UA ? '240px' : '200px'}
                />
              </div>
              <div className="pl4-sm f2">
                <p className="mb2 f3 f4-md fw-medium">{modalTitle}</p>
                <p>{description}</p>
              </div>
            </div>
          );
        })}
        <div className="d-sm-flex justify-center f2 tc mb8-sm mb0-md">
          <p className="ph2">Have other questions?</p>
          <SmartLink
            to={LEARNING_CENTER_PATH}
            className="db purple ph2"
            target="_blank"
          >
            Visit our Learning Center
          </SmartLink>
        </div>
        <button
          type="button"
          className="bg-purple white br3 tc pv2 d-none d-sm-block d-md-none"
          onClick={onCloseClick}
        >
          Back to breeder results
        </button>
      </div>
    </MiniOverlayModal>
  );
}

EducationModuleModal.propTypes = {
  onCloseClick: PropTypes.func.isRequired
};
